export enum CandidateQualificationStatus {
  ACCEPTED,
  REJECTED,
  NOT_INTERESTED
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/candidate-qualification-status.enum.ts